import classNames from 'classnames';

import { Glove } from '@sorare/core/src/assets/icons/Glove';
import { Jersey } from '@sorare/core/src/assets/icons/Jersey';
import { Shield } from '@sorare/core/src/assets/icons/Shield';
import { Shoe } from '@sorare/core/src/assets/icons/Shoe';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconAddPlayer } from '@sorare/core/src/atoms/icons/system/iconAddPlayer.ts';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { css } from '@sorare/css';

const cards = css`
  & > * {
    width: 60px;
    height: 90px;
    border-radius: 8px;
    border: 1px solid var(--c-nd-150);
    color: var(--c-white);
    background: var(--c-nd-50);
    backdrop-filter: blur(8px);
  }
  &.success > * {
    border-color: var(--c-onBase-success);
    color: var(--c-onBase-success);
    background:
      linear-gradient(to left, var(--c-nl-400), var(--c-nl-400)),
      var(--c-surface-success);
    backdrop-filter: none;
  }
`;

type Props = { variant?: 'default' | 'success' };

export const EmptyLineupCards = ({ variant = 'default' }: Props) => {
  return (
    <Horizontal
      center
      className={classNames(cards, { success: variant === 'success' })}
    >
      <Horizontal center>
        <Glove />
      </Horizontal>
      <Horizontal center>
        <Shield />
      </Horizontal>
      <Horizontal center>
        <Jersey />
      </Horizontal>
      <Horizontal center>
        <Shoe />
      </Horizontal>
      <Horizontal center>
        <FontAwesomeIcon icon={iconAddPlayer} size="xs" />
      </Horizontal>
    </Horizontal>
  );
};
